import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter 
} from 'reactstrap';


class DropdownButton extends Component {
  constructor(){
    super();
    this.state = {
      confirmationOptionIndex:null
    };
  }

  handleOptionClick(option,event){
    event.preventDefault();

    if(!option.onClick){ 
      return null;
    } else if(option.onClick && option.confirmationText){

    } else {
      option.onClick(event);
      return;
    }
  }

  handleOptionConfirmClick(option,event){
    option.onClick(event);
    this.setState({confirmationOptionIndex:null});
  }

  handleOptionRejectClick(option,event){
    if(option.onConfirmationFail){
      option.onConfirmationFail(event);
    }
    this.setState({confirmationOptionIndex:null});
  }

  renderDropdownItem(option,index){
    if(option.divider){
      return (
        <DropdownItem divider key={index}/>
      )
    } else if(option.onClick && option.confirmationText){
      return (
        <span key={index}>
          <DropdownItem
            onClick={() => this.setState({confirmationOptionIndex:index})}
          >
            {option.text}
          </DropdownItem>
          <Modal 
            isOpen={this.state.confirmationOptionIndex === index}
            toggle={() => this.setState({confirmationOptionIndex:null})}
          >
            <ModalHeader
              toggle={() => this.setState({confirmationOptionIndex:null})}
            >
              {option.confirmationTitle || 'Are you sure?'}
            </ModalHeader>
            <ModalBody>{option.confirmationText}</ModalBody>
            <ModalFooter>
              <button
                type='button'
                className='btn btn-primary'
                onClick={(e) => this.handleOptionConfirmClick(option,e)}
              >
                {option.confirmationAcceptText || 'Confirm'}
              </button>  
              {option.confirmationRejectText && (
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={(e) => this.handleOptionRejectClick(option,e)}
                >
                  {option.confirmationRejectText}
                </button>    
              )}          
            </ModalFooter>
          </Modal>
        </span>
      )
    } else {
      return (
        <DropdownItem 
          key={index}  
          disabled={option.disabled}
          onClick={(e) => this.handleOptionClick(option,e)}
        >
          {option.text}
        </DropdownItem>
      )
    }
  }

  render(){
    return (
      <UncontrolledButtonDropdown className='DropdownButton'>
        <DropdownToggle>
          {this.props.text || ( <i className='fa fa-ellipsis-v' aria-hidden='true' /> )} 
        </DropdownToggle>
        <DropdownMenu>
          {this.props.options.map((o,i) => this.renderDropdownItem(o,i))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }
}

DropdownButton.propTypes = {
  text:PropTypes.string,
  options:PropTypes.arrayOf(PropTypes.shape({
    divider:PropTypes.bool,
    disabled:PropTypes.bool,
    text:PropTypes.string,
    onClick:PropTypes.func,
    onConfirmationFail:PropTypes.func,
    confirmationTitle:PropTypes.string,
    confirmationText:PropTypes.string,
    confirmationAcceptText:PropTypes.string,
    confirmationRejectText:PropTypes.string
  }))
};

DropdownButton.defaultProps = {
  options:[]
};

export default DropdownButton;



// WEBPACK FOOTER //
// ./src/shared/components/DropdownButton/DropdownButton.js